import { GoogleFontProperties } from 'common/utils/fontsUtils'

export const isDuplicatedGoogleFont = (
  font: GoogleFontProperties,
  fontList: GoogleFontProperties[],
) =>
  fontList.some(
    f =>
      f.fontFamily === font.fontFamily &&
      f.fontWeight === font.fontWeight &&
      f.fontStyle === font.fontStyle,
  )
